import template from './shipmentStatus.html';

export const shiptmentStatusComponent = {
  name: 'shipmentStatus',
  restrict: 'E',
  template,
  controllerAs: 'vm',
  bindings: {
    oldBank: '=',
    newBank: '=',
    shipmentStatus: '=',
  },
};



// WEBPACK FOOTER //
// ./src/app/components/status/components/shipmentStatus/shipmentStatus.component.js